export const formatDateToYYYYMMDD = (input) => {
  if (!input) {
    return '';
  }

  let date;

  if (input instanceof Date) {
    date = input;
  } else if (typeof input === 'string') {
    // Date-only values (e.g. Salesforce `2026-09-01`) are already in the target
    // format; parsing them with `new Date` treats them as UTC midnight and
    // shifts the day back in negative-offset timezones like America/Sao_Paulo.
    if (/^\d{4}-\d{2}-\d{2}$/.test(input)) {
      return input;
    }
    const parsed = new Date(input);
    if (isNaN(parsed)) {
      return '';
    }
    date = parsed;
  } else {
    return '';
  }

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

// Formats a `yyyy-MM-dd` (or ISO) date as `dd/MM/yyyy` without shifting the
// calendar day for date-only values.
export const formatDateToDDMMYYYY = (input) => {
  if (!input) return '';

  const dateOnly = typeof input === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(input);
  const date = input instanceof Date ? input : new Date(dateOnly ? `${input}T00:00:00` : input);
  if (isNaN(date)) return '';

  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');

  return `${day}/${month}/${date.getFullYear()}`;
};

// Formats plain integer client counts with Brazilian thousands separators
// (e.g. 55772 -> "55.772"), regardless of the portal's selected language.
export const formatClientCount = (value) => Number(value || 0).toLocaleString('pt-BR');

